module.exports = __webpack_public_path__ + "static/media/input-search.svg";